import { render, staticRenderFns } from "./BasePartnersShopping.vue?vue&type=template&id=3eb5fc1e&"
import script from "./BasePartnersShopping.vue?vue&type=script&lang=js&"
export * from "./BasePartnersShopping.vue?vue&type=script&lang=js&"
import style0 from "./BasePartnersShopping.vue?vue&type=style&index=0&id=3eb5fc1e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports